import { Pagination } from '../../components/Pagination';
import { actionCreatorFactory } from 'typescript-fsa';
const actionCreator = actionCreatorFactory('Cluster');

export const getClusterList = actionCreator('CLUSTER_LIST_GET');
export const doClusterSearch = actionCreator<{
  query: string;
}>('CLUSTER_LIST_SEARCH');
export const updateClusterList = actionCreator<{
  clusterIds: number[];
  pagination: Pagination;
}>('CLUSTER_LIST_UPDATE');

export const paginateClusterList = actionCreator<{ page: number }>(
  'CLUSTER_LIST_PAGINATE'
);

export const showClusterListLoading = actionCreator('LOADING_SHOW');
export const hideClusterListLoading = actionCreator('LOADING_HIDE');



// WEBPACK FOOTER //
// ./src/store/ClusterList/clusterlist.actions.ts